import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { HandlerMostarListasDTO, Torneo } from "@/interfaces/Torneo";
import { HandlerMostarListasAsync } from "@/services/TorneosService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHandlerMostrarListas',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const isGenerating = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

const successMessage = ref<string>("");
const errorMessage = ref<string>("");

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const confirmarConfiguracion = async () => {
  const mostrar = !props.torneo?.mostrarListas;
  const request: HandlerMostarListasDTO = {
    mostrarListas: mostrar,
    idTorneo: props.torneo?.idTorneo,
  };
  try {
    isGenerating.value = true;
    await HandlerMostarListasAsync(request);
    successMessage.value = mostrar
      ? "Las listas son visibles."
      : "Las listas se han ocultado.";
    showSuccessModal.value = true;
    emit("confirm", mostrar);
  } catch (error) {
    errorMessage.value = mostrar
      ? "Hubo un error al intentar mostrar las listas."
      : "Hubo un error al intentar ocultar las listas.";
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }

  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.torneo?.mostrarListas ? "Ocultar listas" : "Mostrar listas"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "text-center my-4" }, {
              default: _withCtx(() => [
                _createTextVNode(" ¿Estás seguro de que quieres " + _toDisplayString(_ctx.torneo?.mostrarListas ? "ocultar" : "mostrar") + " las listas de los jugadores? ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: confirmarConfiguracion,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.torneo?.mostrarListas ? "Ocultar" : "Mostrar"), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: successMessage.value,
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: errorMessage.value,
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible", "message"])
  ], 64))
}
}

})